export { default as IconSwitch } from './IconSwitch'
